import { get, post, remove, fileDown } from "@/utils/request";
import apiMap from "@/config";

const riskApi = apiMap.riskApi


export const getChannelDetailsList = data =>
  get(`${riskApi}/pubConfig/globalSetting/list`, data);

export const updateBatchPublishGlobalSetting = data =>
  post(`${riskApi}/pubConfig/updateBatchPublishGlobalSetting`, data);

export const getTemplateList = data => post(`${riskApi}/pubConfig/template/list`, data);

export const getPromotionTemplateList = data => get(`${riskApi}/risk/promotionTemplate/all`, data);

export const addPromotionTemplate = data => post(`${riskApi}/risk/promotionTemplate/add`, data);

export const updatePromotionStatus = data => post(`${riskApi}/risk/promotion/updateStatus`, data);

export const updatePromotionTemplate = data => post(`${riskApi}/risk/promotionTemplate/update`, data);

export const addConfig = data => post(`${riskApi}/risk/channel/config/save`, data);

export const configList = data => post(`${riskApi}/risk/channel/config/detail`, data);

export const leagueConfigId = data => post(`${riskApi}/risk/league/detail`, data);

export const deleteConfig = data => post(`${riskApi}/risk/channel/config/delete`, data);

export const LogConfigList = data => post(`${riskApi}/risk/merchantExcludeLeagueLog/list`, data);

export const getTemplateDelete = data =>
  remove(`${riskApi}/risk/riskChannel/deleteMerchantTemplate`, data);

export const getTemplateUpdate = data =>
  post(`${riskApi}/risk/riskChannel/saveOrUpdateTemplate`, data);

export const getTemplateHistory = data =>
  post(`${riskApi}/pubConfig/template/historyList`, data);

export const getChannelList = data =>
  post(`${riskApi}/risk/channel/page`, data);

export const updateMerchantTemplate = data =>
  post(`${riskApi}/risk/riskChannel/updateMerchantTemplate`, data);

export const publish = data =>
  post(`${riskApi}/pubConfig/template/publish`, data);

export const getMerchantHistoryList = data =>
  post(`${riskApi}/risk/riskChannel/getMerchantHistoryList`, data);

export const getWarningTemplateList = data =>
  get(`${riskApi}/risk/channelWarningTemplate/list`, data);

export const getWarningTemplateLogList = data =>
  post(`${riskApi}/risk/channelWarningTemplate/logList`, data);

export const createWarningTemplate = data =>
  post(`${riskApi}/risk/channelWarningTemplate/create`, data);

export const updateWarningTemplate = data =>
  post(`${riskApi}/risk/channelWarningTemplate/update`, data);

export const removeWarningTemplate = data =>
  remove(`${riskApi}/risk/channelWarningTemplate/delete`, data);

export const channelWarningHistory = data =>
  post(`${riskApi}/risk/channelWarnings/page`, data);

export const channelWarningRemark = data =>
  post(`${riskApi}/risk/channelWarnings/remark`, data);

export const downloadChannelWarnings = (data, fileName) =>
  fileDown(`${riskApi}/risk/channelWarnings/download`, data, fileName);

